import { createSlice } from '@reduxjs/toolkit';
import { getRegions } from '../../thunks';
import { IFormState } from '../../types/form';

const initialState: IFormState = {
  regionsList: [],
};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getRegions.fulfilled, (state, action) => {
        state.regionsList = action.payload;
      })
      .addCase(getRegions.rejected, state => {
        state.regionsList = [];
      });
  },
});

export const { reducer: formReducer } = formSlice;
